module.exports = __webpack_public_path__ + "static/media/yu_yun_chang.ba473132.jpg";